module.exports = __webpack_public_path__ + "img/logodefault.19ce7490.png";